import { PopupText } from "app/widgets/referral-modal/referral-modal";
import { WelcomeBanner } from "./dashboard-text-config";

export const cardsData = {
  type: "cards" as const,
  items: [
    {
      _id: "oop1",
      bg: "https://media.alphamind.co/discover-alpha/midle/midle-banner.jpeg",
      logo: "https://media.alphamind.co/discover-alpha/midle/midle-logo.jpg",
      title: "Midle",
      hashtags: "#Task-to-Earn",
      description:
        "Midle is the go-to marketing platform for brands aiming to supercharge user acquisition, engagement, and retention.",
      tags: ["Quest Active"],
      discord: "https://discord.com/invite/EM77DZmP3q",
      tg: "https://t.me/midlecommunity",
      x: "https://x.com/midle_official",
      website: "https://midle.io/",
      hasQuest: true,
      projectAnalystLink:
        "https://media.alphamind.co/discover-alpha/midle/midle_memo.pdf",
      questLink: "https://app.alphamind.co/build_karma?questId=YDyZNUtx",
      roundDetailsData: [],
    },
    {
      _id: "oop2",
      bg: "https://media.alphamind.co/backgrounds/super-meme/supermemo_banner.jpeg",
      logo: "https://media.alphamind.co/backgrounds/super-meme/SuperMeme_logo.png",
      title: "SUPER.MEME",
      hashtags: "#Meme #Infrastructure",
      description:
        "An infrastructure to create and trade community-powered meme coins with rug-free options.",
      tags: ["Quest Finished"],
      discord: "https://discord.com/invite/supermeme",
      tg: "https://t.me/superdotmeme",
      x: "https://x.com/superdotmeme",
      website: "https://super.meme/",
      hasQuest: false,
      projectAnalystLink:
        "https://media.alphamind.co/discover-alpha/super_meme/super.meme%20investment%20memo.pdf",
      questLink: "",
      roundDetailsData: [],
    },
    {
      _id: "12",
      bg: "https://media.alphamind.co/backgrounds/kana-labs/kanalabs-logo-banner.png",
      logo: "https://media.alphamind.co/backgrounds/kana-labs/kanalabs-logo.png",
      title: "Kana Labs",
      hashtags: "#DeFi #Infrastructure",
      description:
        "Kana Labs simplifies DeFi, breaking down the barriers between Web2.0 and Web3.0 so users can enjoy both seamlessly",
      tags: ["Quest Finished"],
      discord: "https://discord.com/invite/CrqCaQ45kZ",
      tg: "https://t.me/kanalabsofficial",
      x: "https://x.com/kanalabs",
      website: "https://kanalabs.io/",
      hasQuest: false,
      projectAnalystLink:
        "https://media.alphamind.co/discover-alpha/kana-labs/kana-labs.pdf",
      questLink: "https://app.alphamind.co/build_karma?questId=JN-6aBIm",
      roundDetailsData: [],
    },
    {
      _id: "11",
      bg: "https://media.alphamind.co/backgrounds/gpt_wars/gpt_wars_banner.png",
      logo: "https://media.alphamind.co/discover-alpha/gpt_wars/gpt_wars_logo.png",
      title: "GPT Wars",
      hashtags: "#GameFi",
      description:
        "First-person shooter survival game on TON, set in a post-apocalyptic dystopian world.",
      tags: ["Quest Finished"],
      discord: "https://discord.com/invite/gptwars",
      tg: "https://t.me/gptwarschat",
      x: "https://x.com/GPTWars",
      website: "https://gptwars.ai/",
      hasQuest: false,
      projectAnalystLink:
        "https://media.alphamind.co/discover-alpha/gpt_wars/gpt_wars_memo.pdf",
      questLink: "https://app.alphamind.co/build_karma?questId=h_XMk-T0",
      roundDetailsData: [],
    },
    {
      _id: "10",
      bg: "https://media.alphamind.co/backgrounds/rapid/RapidNode-banner.png",
      logo: "https://media.alphamind.co/backgrounds/rapid/RapidNode-logo.png",
      title: "Rapid Node",
      hashtags: "#Infrastructure #Node Management",
      description:
        "RapidNode allows anyone to earn effortlessly by purschasing, deploying and managing their nodes on different blockchains",
      tags: ["Quest Finished"],
      discord: "https://discord.gg/gwkxCBPMm5",
      tg: "https://t.me/rapidnode",
      x: "https://twitter.com/rapidnodexyz",
      website: "https://www.rapidnode.xyz/",
      hasQuest: false,
      projectAnalystLink:
        "https://media.alphamind.co/discover-alpha/rapid/RapidNode.pdf",
      questLink: "https://app.alphamind.co/build_karma?questId=eH13GJBb",
      roundDetailsData: [],
    },
    {
      _id: "9",
      bg: "https://media.alphamind.co/backgrounds/eywa/eywa-bg.jpeg",
      logo: "https://media.alphamind.co/backgrounds/eywa/eywa.png",
      title: "EYWA",
      hashtags: "#DeFi #Infrastructure",
      description: "Curve’s official cross-chain data aggregation protocol.",
      tags: ["Quest Finished"],
      discord: "https://discord.gg/eywaprotocol",
      tg: "https://t.me/eywa_en",
      x: "https://twitter.com/eywaprotocol",
      website: "https://eywa.fi/",
      hasQuest: false,
      projectAnalystLink:
        "https://media.alphamind.co/discover-alpha/eywa/EYWA%20Investment%20memo.pdf",
      questLink: "https://app.alphamind.co/build_karma?questId=CzxDoVfj",
      roundDetailsData: [],
    },
    {
      _id: "8",
      bg: "https://media.alphamind.co/backgrounds/clip-finance/clip-finance-bg.jpeg",
      logo: "https://media.alphamind.co/backgrounds/clip-finance/clip-finance-logo.png",
      title: "Clip Finance",
      hashtags: "#DeFi",
      description:
        "An universal liquidity coordination platform with unique TVL-based unlock tokenomics.",
      tags: ["Quest Finished"],
      discord: "https://discord.gg/SvB38aP8rw",
      tg: "https://t.me/clipfinance",
      x: "https://twitter.com/ClipFinance",
      website: "https://www.clip.finance/",
      hasQuest: false,
      projectAnalystLink:
        "https://media.alphamind.co/discover-alpha/clip_finance/clipfinance.pdf",
      questLink: "https://app.alphamind.co/build_karma?questId=Agm1XcCJ",
      roundDetailsData: [],
    },
    {
      _id: "7",
      bg: "https://media.alphamind.co/backgrounds/world-of-dypians/world-of-cypians-bg.jpeg",
      logo: "https://media.alphamind.co/backgrounds/world-of-dypians/WoD-logo.png",
      title: "World of Dypians",
      hashtags: "#GameFi",
      description:
        "The leading BNB Chain gaming ecosystem available on Epic Games.",
      tags: ["Quest Finished"],
      discord: "https://discord.gg/worldofdypians",
      tg: "https://t.me/worldofdypians",
      x: "https://twitter.com/worldofdypians",
      website: "https://www.worldofdypians.com/",
      hasQuest: false,
      projectAnalystLink:
        "https://media.alphamind.co/discover-alpha/Dypians/Investment%20Memo%20World%20of%20Dypians.pdf",
      questLink: "",
      roundDetailsData: [],
    },
    {
      _id: "6",
      bg: "https://media.alphamind.co/backgrounds/zkcross/zkcross.png",
      logo: "https://media.alphamind.co/backgrounds/zkcross/zkcross-logo.png",
      title: "zkCross",
      hashtags: "#Infrastructure",
      description:
        "Advanced chain abstraction infrastructure, enabling blockchains to streamline liquidity onboarding and user engagement.",
      tags: ["Quest Finished"],
      discord: "https://discord.zkcross.network/",
      tg: "https://t.me/zkCrossNetwork",
      x: "https://twitter.com/zkCrossNetwork",
      website: "https://zkcross.network/",
      hasQuest: false,
      projectAnalystLink:
        "https://media.alphamind.co/discover-alpha/zkCross/Investment%20memo%20zkCross.pdf",
      questLink: "",
      roundDetailsData: [],
    },
    {
      _id: "5",
      bg: "https://media.alphamind.co/backgrounds/iagent/iAGENT_banner.jpg",
      logo: "https://media.alphamind.co/backgrounds/iagent/iagent-logo.jpg",
      title: "iAgent",
      hashtags: "#DePIN #AI",
      description:
        "DePIN protocol allowing gamers to train their own AI agents to mimic player behavior from realtime gameplay.",
      tags: ["Quest Finished"],
      discord: "https://discord.gg/iagentprotocol",
      tg: "",
      x: "https://twitter.com/iAgentProtocol",
      website: "https://www.iagentpro.com/",
      hasQuest: false,
      projectAnalystLink:
        "https://media.alphamind.co/discover-alpha/iagent/Investment%20iAgent%20Alphamind%20v4.pdf",
      questLink: "",
      roundDetailsData: [],
    },
    {
      _id: "3",
      bg: "https://media.alphamind.co/backgrounds/astra-nova/astra-nova-bg.jpeg",
      logo: "https://media.alphamind.co/backgrounds/astra-nova/astra-nova.jpg",
      title: "Astra Nova",
      hashtags: "#GameFi",
      description: "The revolutionary Web3 RPG co-created by and for gamers.",
      tags: ["Quest Finished"],
      discord: "https://discord.com/invite/YQusFqaf6c",
      tg: "https://t.me/astranovaofficial",
      x: "https://x.com/Astra__Nova",
      website: "https://astranova.world/",
      hasQuest: false,
      projectAnalystLink:
        "https://media.alphamind.co/discover-alpha/astra_nova/Investment%20Astra%20Nova%20Alphamind%20V3.pdf",
      questLink: "https://app.alphamind.co/build_karma?questId=kIJXB5IQ",
      roundDetailsData: [],
    },
    {
      _id: "2",
      bg: "https://media.alphamind.co/backgrounds/nexis/nexis.jpeg",
      logo: "https://media.alphamind.co/backgrounds/nexis/nexis-logo.png",
      title: "Nexis",
      hashtags: "#L1 #AI",
      description:
        "The world's first layer-1 blockchain built for real-time data access for AI and Machine Learning.",
      tags: ["Quest Finished"],
      discord: "https://discord.com/invite/v4nM2JxGBd",
      tg: "https://t.me/Nexis_Network",
      x: "https://x.com/Nexis_Network",
      website: "https://nexis.network/",
      hasQuest: false,
      projectAnalystLink:
        "https://media.alphamind.co/discover-alpha/nexis/Investment%20nexis%20Alphamind%20V3.pdf",
      questLink: "",
      roundDetailsData: [],
    },
    {
      _id: "1",
      bg: "https://media.alphamind.co/backgrounds/dyor/DYOR_banner.png",
      logo: "https://media.alphamind.co/backgrounds/dyor/dyor-logo.png",
      title: "DYOR",
      hashtags: "#SocialFi #DeFi",
      description:
        "Decentralized social investing app to help new investors discover and invest in Web3 projects.",
      tags: ["Quest Finished"],
      discord: "https://discord.com/invite/dyorexchange",
      tg: "https://t.me/dyorexchange",
      x: "https://x.com/dyorexchange",
      website: "https://dyor.exchange/",
      hasQuest: false,
      projectAnalystLink:
        "https://media.alphamind.co/discover-alpha/dyor_memo/Investment%20Memo%20Alphamind.pdf",
      questLink: "",
      roundDetailsData: [],
    },
  ],
};

// export const idoData = {
//   type: 'ido' as const,
//   items: [
//     {
//       id: '6737b1a039537711bcd813a6',
//       bg: 'https://media.alphamind.co/backgrounds/eywa/eywabg.jpeg',
//       logo: 'https://media.alphamind.co/backgrounds/eywa/eywalogo.jpeg',
//       title: 'EYWA IDO',
//       tokenTicker: '$EYWA',
//       totalRaise: '1,000,000 USDT',
//       pricePerToken: '$0.07',
//       supportedNetworks: ['Linea'],
//       claimNetwork: 'Linea',
//       raiseCurrency: 'USDT',
//       claimType: 'Claim on Alphamind',
//       exchangeRate: '1 EYWA = 0.07 USDT',
//       swapAmount: '1,000,000 EYWA',
//       price: 0.07,
//       whitelistStartDate: '2024-11-16T12:00:00Z',
//       whitelistEndDate: '2024-11-23T23:55:00Z',
//       sellStartDate: '2024-11-25T12:00:00Z',
//       sellEndDate: '2024-11-30T12:00:00Z',
//       claimStartDate: '2024-12-15T12:00:00Z',
//       claimEndDate: '2024-12-31T12:00:00Z',
//       stage: 'whitelist' as 'whitelist',
//       totalTokens: 1000000,
//       soldTokens: 500000,
//       description: `The Cross-Chain DeFi Protocol for Seamless Interoperability.`,
//       requirements: {
//         tierRequired: false,
//         kycRequired: false,
//         socialActivities: true,
//       },
//       socialLinks: {
//         discord: 'https://discord.gg/eywaprotocol',
//         twitter: 'https://twitter.com/eywaprotocol',
//         website: 'https://eywa.fi/',
//         telegram: 'https://t.me/eywa_en',
//       },
//       stages: [
//         { name: 'Whitelist', date: '2024-11-23T23:55:00Z' },
//         { name: 'Allocation Confirmed', date: '2024-11-24T23:55:00Z' },
//         { name: 'Token Launch', date: '' },
//         { name: 'Tokens Claim', date: '' },
//       ],
//       currentStage: 'whitelist' as 'whitelist',
//       tokenMetricsData: [
//         { label: 'Token Ticker', value: '$EYWA' },
//         { label: 'Token Price', value: '1 EYWA = $0.07' },
//         { label: 'Total Supply', value: '1,000,000,000 EYWA' },
//         { label: 'KYC Required', value: 'No' },
//         { label: 'Vesting Terms', value: 'Linear / 12 months.' },
//       ],
//       roundDetailsData: [
//         { label: 'FDV (Fully Diluted Valuation)', value: '$70M' },
//         { label: 'IMC (Initial Market Cap)', value: '$843K' },
//         { label: 'TGE Unlock', value: '15%' },
//         { label: 'Raise Currency', value: 'USDT' },
//         { label: 'Network', value: 'Linea' },
//         { label: 'Allocation Type', value: 'Tiered (Karma-based).' },
//       ],
//       tokenUtilityData: [
//         { label: 'Fee Distribution', description: 'Stake $EYWA for fees.' },
//         { label: 'Governance', description: 'Vote with $EYWA.' },
//         { label: 'Incentives', description: 'Boost Farming Rewards.' },
//         { label: 'Secondary Market', description: 'Sell vested $EYWA w/ EYWA NFT' },
//       ],
//       airdropDesc: 'Join <b>$EYWA</b> token launch on AlphaMind and secure a guaranteed <b>$EYWA</b> airdrop in Season 2!',
//       airdropSub: 'Airdrop: guaranteed for AlphaMind & Linea Community!',
//       eywaHowToGet: `<b>Step 1: Join the Whitelist</b>
//                     <br/>
//                     <br/>
//                     Click the ‘Apply to Whitelist’ button above to secure your spot and start your journey!
//                     Joining early increases your chances of guaranteed allocation during the token sale.
//                     <br/>
//                     <br/>
//                     <b>Step 2: Fund Your Wallet</b>
//                     <br/>
//                     <br/>
//                     Make sure your wallet is funded and ready to transact on the Linea network with supported currencies.(USDT for buying <b>$EYWA</b>, ETH for gas).
//                     <br/>
//                     <br/>
//                     <b>Step 3: Boost Your Karma Score</b>
//                     <br/>
//                     <br/>
//                     Higher Karma means better allocation!
//                     Complete quests and grow your score to climb to the next tier before the snapshot.
//                     <br/>
//                     <br/>
//                     Visit <a href='https://app.alphamind.co/build_karma' target='_blank'><b>Quests</b></a> and complete tasks to earn more Karma points.
//                     <br/>
//                     <br/>
//                     <b>Useful Resources:</b><br/><br/>
//                     — Need funds on the Linea network? Use one of these trusted platforms: <a href='https://app.crosscurve.fi/swap' target='_blank'><b>EYWA</b></a> | <a href='https://app.routernitro.com/swap?referal=RT1731698421258' target='_blank'><b>Nitro</b></a><br/>
//                     — How to Participate in an IDO (link to a blog article).<br/>
//                     — Contact Support on <a href='https://discord.com/invite/NB4hhuXkWz' target='_blank'><b>Discord</b></a> if you have any questions.`,
//       eywaDescription:`<b>EYWA</b> is solving DeFi’s biggest        challenges—fragmented liquidity and cross-chain inefficiencies—by creating a unified cross-chain liquidity market.
//                     <br/>
//                     <br/>
//                     <b>Flagship Product:</b> CrossCurve DEX consolidates over $2B in Curve liquidity, enabling low-slippage cross-chain swaps of assets like stables, LSTs, and Curve LPs—all in one click.
//                     <br/>
//                     <br/>
//                     <b>Innovative Tech:</b> Backed by the secure EYWA Consensus Bridge, ensuring the safety of funds in cross-chain operations.
//                     <br/>
//                     <br/>
//                     <b>Traction:</b> $650M+ trading volume, $13.7M TVL, 800K+ transactions, and over 100K unique users.
//                     <br/>
//                     <br/>
//                     <b>Backers:</b><br />
//                     EYWA is backed by top VCs like Fenbushi Capital, GBV Capital, Marshland Capital and led by Michael Egorov, the founder of Curve Finance, strengthening its position in the DeFi ecosystem.`,
//       eywaSubtitle: 'EYWA: The Future of Cross-Chain Liquidity',
//       name: 'EYWA Community Launch',
//     },
//     {
//       id: '2',
//       bg: 'https://media.alphamind.co/backgrounds/eywa/eywabgsec.jpg',
//       logo: 'https://media.alphamind.co/backgrounds/eywa/eywalogo.jpeg',
//       title: 'EYWA Early Supporters',
//       tokenTicker: '$EYWA',
//       totalRaise: '1,000,000 USDT',
//       pricePerToken: '$0.07',
//       supportedNetworks: ['Arbitrum'],
//       claimNetwork: 'Arbitrum',
//       raiseCurrency: 'USDT',
//       claimType: 'Claim on Alphamind',
//       exchangeRate: '1 EYWA = 0.07 USDT',
//       swapAmount: '1,000,000 EYWA',
//       price: 0.07,
//       whitelistStartDate: '2024-11-16T12:00:00Z',
//       whitelistEndDate: '2024-11-16T23:55:00Z',
//       sellStartDate: '2024-11-25T12:00:00Z',
//       sellEndDate: '2024-11-30T12:00:00Z',
//       claimStartDate: '2024-12-15T12:00:00Z',
//       claimEndDate: '2024-12-31T12:00:00Z',
//       stage: 'swap' as 'swap',
//       totalTokens: 1000000,
//       soldTokens: 500000,
//       description: `The Cross-Chain DeFi Protocol for Seamless Interoperability.`,
//       requirements: {
//         tierRequired: false,
//         kycRequired: false,
//         socialActivities: true,
//       },
//       socialLinks: {
//         discord: 'https://discord.gg/eywaprotocol',
//         twitter: 'https://twitter.com/eywaprotocol',
//         website: 'https://eywa.fi/',
//         telegram: 'https://t.me/eywa_en',
//       },
//       stages: [
//         { name: 'Whitelist', date: '2024-11-16T23:55:00Z' },
//         // { name: 'Allocation Confirmed', date: '2024-11-24T23:55:00Z' },
//         { name: 'Token Launch', date: '2024-11-25T23:55:00Z' },
//         { name: 'Tokens Claim', date: '2024-12-15T23:55:00Z' },
//       ],
//       currentStage: 'Allocation Confirmed' as 'swap',
//       allocSystem: 'EYWA Whitelist',
//       name: 'EYWA Early Supporters Sale',
//       tokenMetricsData: [
//         { label: 'Token Ticker', value: '$EYWA' },
//         { label: 'Token Price', value: '1 EYWA = $0.07' },
//         { label: 'TGE Unlock', value: '15%' },
//         { label: 'Total Supply', value: '1,000,000,000 EYWA' },
//         { label: 'KYC Required', value: 'No' },
//         { label: 'Vesting Terms', value: 'Linear / 12 months.' },
//       ],
//       roundDetailsData: [
//         { label: 'FDV (Fully Diluted Valuation)', value: '$70M' },
//         { label: 'IMC (Initial Market Cap)', value: '$843K' },
//         { label: 'Raise Currency', value: 'USDT, USDC' },
//         { label: 'Network', value: 'Arbitrum' },
//         { label: 'Min Allocation', value: '$100' },
//         { label: 'Max Allocation', value: '$10 000' },

//       ],
//       tokenUtilityData: [
//         { label: 'Fee Distribution', description: 'Stake $EYWA for fees.' },
//         { label: 'Governance', description: 'Vote with $EYWA.' },
//         { label: 'Incentives', description: 'Boost Farming Rewards.' },
//         { label: 'Market', description: 'Sell vested $EYWA w/ EYWA NFT' },
//       ],
//       airdropDesc: 'Join <b>$EYWA</b> token launch on AlphaMind and secure a guaranteed <b>$EYWA</b> airdrop in Season 2!',
//       airdropSub: 'Airdrop: guaranteed for AlphaMind & Linea Community!',
//       eywaHowToGet: `
//                     <b>Step 1: Fund Your Wallet</b>
//                     <br/>
//                     <br/>
//                     Make sure your wallet is funded and ready to transact on the Linea network with supported currencies.(USDT for buying <b>$EYWA</b>, ETH for gas).
//                     <br/>
//                     <br/>
//                     <b>Step 2: Boost Your Karma Score</b>
//                     <br/>
//                     <br/>
//                     Higher Karma means better allocation!
//                     Complete quests and grow your score to climb to the next tier before the snapshot.
//                     <br/>
//                     <br/>
//                     Visit <a href='https://app.alphamind.co/build_karma' target='_blank'><b>Quests</b></a> and complete tasks to earn more Karma points.
//                     <br/>
//                     <br/>
//                     <b>Useful Resources:</b><br/><br/>
//                     — Need funds on the Linea network? Use one of these trusted platforms: <a href='https://app.crosscurve.fi/swap' target='_blank'><b>EYWA</b></a> | <a href='https://app.routernitro.com/swap?referal=RT1731698421258' target='_blank'><b>Nitro</b></a><br/>
//                     — How to Participate in an IDO (link to a blog article).<br/>
//                     — Contact Support on <a href='https://discord.com/invite/NB4hhuXkWz' target='_blank'><b>Discord</b></a> if you have any questions.`,
//       eywaDescription:`<b>EYWA</b> is solving DeFi’s biggest        challenges—fragmented liquidity and cross-chain inefficiencies—by creating a unified cross-chain liquidity market.
//                     <br/>
//                     <br/>
//                     <b>Flagship Product:</b> CrossCurve DEX consolidates over $2B in Curve liquidity, enabling low-slippage cross-chain swaps of assets like stables, LSTs, and Curve LPs—all in one click.
//                     <br/>
//                     <br/>
//                     <b>Innovative Tech:</b> Backed by the secure EYWA Consensus Bridge, ensuring the safety of funds in cross-chain operations.
//                     <br/>
//                     <br/>
//                     <b>Traction:</b> $650M+ trading volume, $13.7M TVL, 800K+ transactions, and over 100K unique users.
//                     <br/>
//                     <br/>
//                     <b>Backers:</b><br />
//                     EYWA is backed by top VCs like Fenbushi Capital, GBV Capital, Marshland Capital and led by Michael Egorov, the founder of Curve Finance, strengthening its position in the DeFi ecosystem.`,
//       eywaSubtitle: 'EYWA: The Future of Cross-Chain Liquidity',
//     },
//   ],
// };

export const idoFilters = [
  { label: "Whitelist Open", value: "whitelist open" },
  { label: "Whitelist Closed", value: "whitelist closed" },
  { label: "Upcoming IDO", value: "upcoming IDO" },
  { label: "Finished IDO", value: "finished IDO" },
];

export const idoPageData = {
  title: "Early Access to the Next Big Crypto Projects",
  description: `Discover tomorrow's leading tokens. Join token launches of the breakthrough web3 projects selected for you. Get on the whitelist now!`,
};

export const filters = [
  { label: "Quest Active", value: "quest active" },
  { label: "Voting", value: "voting" },
  { label: "Quest Finished", value: "Quest finished" },
];

export const welcomeBannerMain: WelcomeBanner = {
  title: "Discover Alpha",
  description:
    "Access to hot pipeline of selected Alpha projects, unlock investment memos, participate in voting & launch deicision-making. Earn rewards by engaging",
};

export const pageData = {
  title: "Alpha Projects",
  description:
    "Review the pre-selected Alpha Projects and engage in ongoing quest & voting for the best projects to launch next!",
};

export const eywaMemoLink =
  "https://media.alphamind.co/discover-alpha/eywa/EYWA%20Investment%20memo.pdf";

export const eywaFaq = `
Need help or have issues? Contact us on <a href='https://discord.com/invite/NB4hhuXkWz' target='_blank'><b>Discord</b></a> or <a href='https://t.me/alphamind_official' target='_blank'><b>Telegram</b></a>.
<br />
<br />


FAQs:<br />
How do I claim tokens post-TGE?<br />
Sic de isto et tutius perducit ad actum ipsum, ut si dico “Ego autem vadam lavari, ut mens mea in statu naturae.”<br /><br />

What is the vesting schedule?<br />
15% unlock at TGE; 85% linearly over 12 months`;

export const eywaFaq2 = `
Need help or have issues?<br /> Contact us on <a href='https://discord.com/invite/NB4hhuXkWz' target='_blank'><b>Discord</b></a> or <a href='https://t.me/alphamind_official' target='_blank'><b>Telegram</b></a>.
<br />
<br />
How to bridge funds to Arbitrum?<br />
Test the EYWA Bridge to move funds to Arbitrum:<br />

<a href='https://app.crosscurve.fi/swap' target='_blank'><b>Crosscurve</b></a><br /><br />

What is the vesting schedule?<br /><br />
15% unlock at TGE; 85% linearly over 12 months`;

export const message = `Token Acquisition Agreement

The person accepting this Agreement via electronic means becomes the party (“Purchaser”) to the terms and conditions set out below. The “Company” in this Agreement is FBX Technology Ltd, incorporated with limited liability under the laws of British Virgin Islands. under company number 2090058 , having its registered office at Intershore Chambers, Road Town, Tortola, British Virgin Islands -------------.

Preamble

WHEREAS the Company is involved in the development of XProtocol_________________________________________________________________________________________________________________________________________(Protocol) which consists of software deployed or to be deployed on the internet across a number of blockchains and protocols (such as tokens or digital coins). The Protocol is described in more detail on the website of the developers of the Protocol (https://xprotocol.org) and specifically the Documents section (https://docs.xprotocol.org)(“Docs”) which set out the main parameters and functions of the software, and-

WHEREAS digital modules (Tokens) will be generated by the Protocol which will technically enable their controllers (whether those are persons or software, such as ‘smart contracts’) to interact with the Protocol in ways explained in detail in the Docs, and to enjoy certain privileges and options laid out in the Docs, -

The Purchaser has expressed interest in acquiring a number of Tokens thus generated and has contacted the Company to facilitate such acquisition.

The following has been agreed:

1.	Important legal considerations

The Purchaser confirms that it understands the following, and enters into this Agreement on the basis of such understanding:

The Company makes no representation as to the legal nature of the Tokens under the laws of any country. The tokens are not ‘issued’ by any entity, are not legal obligations of any entity and do not represent any such obligations.

The Company is not the ‘issuer’ of the Tokens or any rights therein. The Tokens are software modules enabling direct interaction between their controller/user and the software comprising the Protocol, and do not create or presume any interaction or relationship between their controller/user and the Company.

The Company undertakes to procure that the Purchaser shall receive under the Purchaser’s control the agreed number of Tokens and with the completion of that the Purchaser’s relationship with the Company shall cease. The ‘life’ and functionality of the Tokens shall be controlled by software developed within the framework of the Protocol and its in-built user governance mechanisms.

2.	Procurement of Tokens

The Company shall, at the request of the Purchaser, and for the consideration herein described, procure that when the Tokens are generated by the Protocol, the Purchaser shall receive under its control the number of Tokens which the Purchaser indicated, and completed the payment for, at the electronic platform used for the automated processing of the Token acquisition, namely https://app.alphamind.co/ (the “Sales Platform”). The electronic records of the Sales Platform shall be conclusive evidence of the quantity of Tokens acquired by the Purchaser and the payment amount advanced. Payment in USDT (stablecoin known as Tether) will be processed through designated blockchain addresses or smart contracts provided by the Company and integrated into the Sales Platform. These blockchain addresses or smart contracts are owned by the Company. The specific details for the transaction will be provided to the Purchaser via the Sales Platform at the time of purchase.

Following the receipt of the Tokens on the Purchaser’s address linked in the electronic records of the Sales Platform to this transaction, the Company’s obligations to the Purchaser shall be deemed fulfilled, and this Agreement shall cease, except for Clause 4.

3.	The Company’s warranties and representations

The Company is a legal entity, duly incorporated and validly existing under the laws of its place of incorporation. The Company has the requisite power to enter into this Agreement in accordance with the laws of its place of incorporation and its own constituent documents.

4.	Warranties and representations by the Purchaser

4.1	This Agreement was privately negotiated, entirely at the initiative of the Purchaser. The Company has not given, and the Purchaser has no grounds to state that it received from the Company (which includes any of its employees, officers or agents) any warranties or representations apart from those stated in Clause 3 above.

4.2	The Purchaser has made own inquiries as to the technical properties of the Tokens and the utility of the Protocol they enable to interact with, and wishes to proceed with their purchase for the primary motives of (1) using the Protocol, and (2) participating in the further development of the Protocol. Being a person with keen interest in new blockchain technologies, and in particular, the development, maturity and safety of the ‘decentralized finance’ ecosystem, the Purchaser considers that the main benefit the Purchaser can obtain from the purchase of the Tokens is the development of the Protocol for the benefit of the ecosystem in general (which the Purchaser is and further intends to be a user of).

4.3	The Purchaser understands that the purchase of the Tokens carries the many typical risks of participating in projects associated with blockchain technologies as well as risks specific to the Protocol. It is understood that the Protocol and the Tokens are software under development, and the Purchaser is willing to acquire the Tokens on “as is” basis.

4.4	By executing this Agreement the Purchaser assures the Company that the Purchaser’s designated blockchain address is not controlled, managed, administered or otherwise held on behalf of any person who is:
a politically exposed person, by FATF definition; or
included in any list of sanctions or restrictive measures issued by the United Nations, European Union, United Kingdom, Canada, United States of America, Australia or Switzerland;
not a resident of the following territories:
Afghanistan
Belarus
Central African Republic
Venezuela
Cuba
The United States of America (USA)
Myanmar (Burma)
Iran
Somalia
Democratic People’s Republic of Korea
Syrian Arab Republic
Residents of the Crimea Peninsula and the self-proclaimed ‘People’s Republics’ of Luhansk and Donetsk
The self-proclaimed Republic of Abkhazia
The self-proclaimed Republic of Trans-Dniestria
The self-proclaimed Republic of South Ossetia

Access and use of related services, participation in any sale or distribution of tokens or products are intended solely for users who comply with the regulations under the laws of their respective jurisdictions. The product and services are not available for residents of Restricted Territories, as well as for residents of the territories above.

5.	Miscellaneous

This Agreement shall be governed by and construed in accordance with substantive domestic law of British Virgin Islands. Any disputes hereunder which have not been resolved amicably following a 30 business days settlement procedure initiated by either party, shall be referred to State courts in the defendant’s place of incorporation/residence, in accordance with the local law of procedure. This Agreement is drawn up in English only; any translation is at the discretion of either party.
`;

export const mainPageBanner =
  "https://media.alphamind.co/backgrounds/zkcross/new_banner_cross.jpeg";

export const TGLink = "https://t.me/AlphaIDO_bot?start=";

export const loginMessage =
  "I accept the Terms of Service and Privacy Policy.I acknowledge that participating in the IDO may involve economic, technical, and regulatory risks, which I fully accept.I acknowledge that AlphaMind is solely a technology platform connecting me with projects. AlphaMind is not responsible for the projects presented on the platform, including their legal compliance, fulfillment of obligations, or accuracy of the information provided. AlphaMind is not a party to the transactions or payments made between me and the projects, nor is it a beneficiary or owner of the smart contracts during the IDO.I confirm that I am not a resident of the U.S. I confirm that I am not a resident of a jurisdiction where the use of AlphaMind is prohibited by local laws. I assure that I fully comply with AML/CFT regulations, I am not a politically exposed person, nor a person subject to restrictions under U.S., EU, or UN sanction lists.";

export const tokenMetricsData = [
  { label: "Token Price", value: "$0.00375" },
  { label: "FDV", value: "$30M" },
  { label: "IMC", value: "$1,5M" },
  { label: "TGE Unlock", value: "100%" },
  { label: "Raise Currency", value: "USDT, USDC" },
  { label: "Allocation", value: "SmartWhitelist" },
  { label: "TGE Date", value: "Q1 2025" },
];

export const popupMain: PopupText = {
  title: "🎉 You did it! Welcome aboard!",
  description:
    "Your move? 🔥 Legendary! Want more, here is your exclusive referral link, ready to start working for you:👉",
  copyText: `💸 Here's the deal:`,
  one: `• Every time someone uses your link to make a purchase, you’ll instantly </br><b>pocket 1% of their transaction during the IDO.</b>`,
  four: "Yup, you earn while they participate 🔥",
  two: `📈 Got friends looking to join the zkCross Network IDO? Share your link, spread the word, and watch your rewards grow.`,
  three: `🚀 Start sharing and let the rewards roll in!`,
  hasCopyLink: true,
  errorTitle: "Ooops... Something wrong!",
  errorText: "Please, refresh the page",
};

export const tiers = [
  {
    name: "Tier 1",
    description: "5% commission",
    range: "$10,000+ referred",
    min: 10000,
    color: "#4BC0C0",
  },
  {
    name: "Tier 2",
    description: "4% commission",
    range: "$5,000 – $9,999",
    min: 5000,
    color: "#36A2EB",
  },
  {
    name: "Tier 3",
    description: "3% commission",
    range: "$2,000 – $4,999",
    min: 2000,
    color: "#9966FF",
  },
  {
    name: "Tier 4",
    description: "2% commission",
    range: "$500 – $1,999",
    min: 500,
    color: "#FFCE56",
  },
  {
    name: "Tier 5",
    description: "1% commission",
    range: "under $500",
    min: 0,
    color: "#FF6384",
  },
];

export const colorSchema = {
  light: {
    gradients: [
      "url(#lightGradient1)",
      "url(#lightGradient2)",
      "url(#lightGradient3)",
      "url(#lightGradient4)",
    ],
    stroke: "#ffffff79",
    text: "#2d3748",
  },
  dark: {
    gradients: [
      "url(#darkGradient1)",
      "url(#darkGradient2)",
      "url(#darkGradient3)",
      "url(#darkGradient4)",
    ],
    stroke: "#2d374879",
    text: "#f8f8f8",
  },
};
